// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__IPftL","footer":"ReportModalFilter_footer__3B3gO"};